// Story 15.7 — Screen 23's four platform stat tiles.
//
// Its own read, and NOT `useAdminConsole`. Screen 23 used to mount the console
// hook for these four integers, which made every load of the organization
// directory write a `super_admin.console.viewed` audit row for a console nobody
// opened and pay for a platform-wide entitlement resolution the screen never
// renders (DW-423). Those rows are append-only and kept seven years, so the
// split had to happen before merge rather than after.
//
// Mirrors `useAdminOrgs` in shape, minus the filters: the totals are estate-wide
// aggregates, deliberately unaffected by the directory's search box, so the read
// takes no parameters and the query key is a bare constant.

import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { AdminOrgTotals } from "@/hooks/queries/admin-org-totals-types";

export const ADMIN_ORG_TOTALS_QUERY_KEY = "admin-org-totals";

export function adminOrgTotalsQueryKey() {
  return [ADMIN_ORG_TOTALS_QUERY_KEY] as const;
}

export function adminOrgTotalsPath(): string {
  return "/admin/orgs/totals";
}

export function useAdminOrgTotals() {
  return useQuery({
    queryKey: adminOrgTotalsQueryKey(),
    queryFn: () => apiFetch<AdminOrgTotals>(adminOrgTotalsPath()),
    // A refusal (403 for a non-super_admin) is terminal for this read; retrying
    // only delays the screen settling into its without-tiles state.
    retry: false,
  });
}
